<template>
  <div>
    <div class="content">
      <div class="innerTitle">
        <el-button type="primary" size="small" @click="add">新增</el-button>
        <div class="screenBox">
          <el-cascader
            v-model="cascaderArr"
            :options="options"
            :props="props"
            size="small"
            style="width: 47%"
            clearable
            @change="handleChange">
          </el-cascader>
          <el-select v-model="searchForm.status" size="small" style="width: 47%" placeholder="请选择状态" @change="selectChange" clearable>
            <el-option label="预审批" :value="0" />
            <el-option label="部门审批" :value="1" />
            <el-option label="公司审批" :value="2" />
            <el-option label="审批完成" :value="3" />
          </el-select>
        </div>
      </div>
      <div class="tableBox">
        <el-table
        :data="tableData"
        border
        :header-cell-style="{ background: 'rgb(232,232,232)', height: '55px', textAlign: 'center' }"
        :row-style="{ height: '55px' }"
        :cell-style="{ textAlign: 'center' }"
        style="width: 100%">
        <el-table-column
          type="index"
          :index='(index) => {return index + 1 + (curPage-1)*limit}'
          label="序号"
          width="100">
        </el-table-column>
        <el-table-column
          prop="resTitle"
          label="标题">
        </el-table-column>
        <el-table-column
          prop="resDepName"
          label="部门">
        </el-table-column>
        <el-table-column
          prop="resJobName"
          label="岗位">
          </el-table-column>
        <el-table-column
          prop="yeas"
          label="年度">
        </el-table-column>
        <el-table-column
          prop="proName"
          label="制定人">
        </el-table-column>
        <el-table-column
          prop="creationTime"
          width="100"
          label="制定日期">
          <template slot-scope="{ row }">
            {{ row.creationTime | timeFilter }}
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          label="状态">
          <template slot-scope="{ row }">
            <span v-if="row.status === 0" style="color: #E6A23C">预审批</span>
            <span v-if="row.status === 1" style="color: #409EFF">部门审批</span>
            <span v-if="row.status === 2" style="color: #409EFF">公司审批</span>
            <span v-if="row.status === 3" style="color: #67C23A">审批完成</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作">
          <template slot-scope="{ row }">
            <el-link type="primary" style="margin-right: 10px" @click="edit(row)" v-if="row.status === 0">编辑</el-link>
            <el-link type="primary" style="margin-right: 10px" @click="detail(row.id)">详情</el-link>
            <el-link type="danger" @click="deleteList(row)">删除</el-link>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 15px; text-align: right">
        <Page :total='total' :page-size='limit' :current='curPage' @on-change='curPageChange' />
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getResponseBookList, responseBookDelete, getAllDepartment } from '@/api/processManager'
export default {
  name: 'mainTarget',
  data() {
    return {
      searchForm: {
        resJobId: '',
        resDepId: '',
        status: ''
      },
      typeList: [
        { id: 0, name: '年度目标' },
        { id: 1, name: '季度目标' },
        { id: 2, name: '月度目标' },
      ],
      levelList: [
        { id: 1, name: '公司级' },
        { id: 2, name: '部门级' },
      ],
      tableData: [],
      limit: 10,
      total: 0,
      curPage: 1,
      // 级联选择器
      options: [],
      props: {
        label: 'name',
        children: 'jobVos',
        value: 'id'
      },
      cascaderArr: []
    }
  },
  created() {
    this.getData()
    this.getAllDepartment()
  },
  methods: {
    // 获取数据
    getData() {
      getResponseBookList({ limit: this.limit, curPage: this.curPage, ...this.searchForm }).then(res => {
        this.tableData = res.body.data;
        this.total = res.body.cum
      })
    },
    // 获取所有部门和下面的岗位
    getAllDepartment() {
      getAllDepartment().then(res => {
        this.options = res.body.data
      })
    },
    // 级联选择器的事件
    handleChange(value) {
      // console.log(value);
      // return
      if(value.length !== 0) {
        this.searchForm.resJobId = value[1],
        this.searchForm.resDepId = value[0]
      }
      else {
        this.searchForm.resJobId = ''
        this.searchForm.resDepId = ''
      }
      this.getData()
    },
    // 下拉框选择的事件
    selectChange() {
      this.getData();
    },
    // 翻页
    curPageChange(val) {
      this.curPage = val;
      this.getData();
    },
    // 新增按钮
    add() {
      this.$router.push({
        path: 'positionAdd'
      })
    },
    // 编辑
    edit(row) {
      this.$router.push({
        name: 'positionAdd',
        params: { ...row }
      })
    },
    // 删除
    deleteList(row) {
      this.$confirm(`删除 ${row.resTitle }, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        responseBookDelete(row.id).then(res => {
          this.$message.success('删除成功');
          this.getData();
        })
      }).catch(() => {
        return      
      });
    },
    // 详情/审核
    detail(id) {
      this.$router.push(`positionDetail/${id}`)
    },
    // 跳转到拆分新增页面
    jumpSplit(row) {
      console.log(row)
      this.$router.push({
        name: 'targetSplitAdd',
        params: { jumpStatus: true, goalId: row.id }
      })
    }
  }
}
</script>

<style scoped>
.innerTitle {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}
.innerTitle .screenBox {
  width: 30%;
  display: flex;
  justify-content: space-between;
}
</style>